module.exports = __webpack_public_path__ + "static/media/tracey-intro-3.1d9f8f65.wav";